import React from 'react'
import ContactLayout from './Contact/contactlayout';
import ContactForm from "./Contact/contactfrom";

const Contact = () => {
    return (
        <ContactLayout>
            <ContactForm />
        </ContactLayout>
    )
}

export default Contact
